import comp from '../components/barrel';
import svg from '../js/svg';

const text = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') return '—';
  return String(value);
};

const yesNo = (value) => (value ? 'Yes' : 'No');

export default {
  application_uuid: null,
  flaggedYn: false,
  logApplicationViewUuid: null,
  async prepare() {
    this.application_uuid =
      this.vars?.application_uuid ||
      thsPage?.vars?.application_uuid ||
      thsPage?.application_uuid;

    const vars = { application_uuid: this.application_uuid };
    this.recipe.methods.push(await O.mPOST('application/get-application-detail', vars));
    this.recipe.methods.push(await O.mPOST('application/get-app-summary', vars));
  },
  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(data) {
    this.applicationDetail = data['application/get-application-detail']?.data || null;
    const summary = data['application/get-app-summary']?.data || {};
    this.applyFlagState(summary);
    await this.renderStatus(summary);
    this.renderAdvisor(summary);
    this.renderWill(summary);
    this.renderParties(summary);
  },
  applyFlagState(summary) {
    const viewUuid = summary.log_application_view_uuid;
    this.logApplicationViewUuid =
      viewUuid != null && String(viewUuid).trim() !== '' ? String(viewUuid).trim() : null;
    this.flaggedYn =
      summary.flagged_yn === true || summary.flagged_yn === 'true' || summary.flagged_yn === 1;
  },
  async renderStatus(summary) {
    const row = U.id('clientOverviewStatus');
    if (!row) return;
    row.innerHTML = '';
    const status = await comp.statusTag(summary.status);
    row.appendChild(status);
    this.renderFlag(row);
  },
  renderAdvisor(summary) {
    const row = U.id('clientOverviewAdvisor');
    if (!row) return;
    row.innerHTML = '';
    row.appendChild(comp.displayText('clientAdvisorName', text(summary.advisor), 'Name'));
    row.appendChild(comp.displayText('clientAdvisorTel', text(summary.advisor_cell_nr), 'Telephone number'));
    row.appendChild(comp.displayText('clientAdvisorEmail', text(summary.advisor_email_address), 'Email address'));
  },
  renderWill(summary) {
    const row = U.id('clientOverviewWill');
    if (!row) return;
    row.innerHTML = '';
    const willNumber = summary.h_will_id != null ? summary.h_will_id : summary.will_nr;
    row.appendChild(comp.displayText('clientWillNumber', text(willNumber), 'Will number'));
    row.appendChild(comp.displayText('clientTestament', text(summary.testament), 'Testament'));
    row.appendChild(
      comp.displayText('clientAmendedWill', yesNo(summary.app_type === 'Amended will'), 'Amended will')
    );
    row.appendChild(comp.displayText('clientOffshoreWill', yesNo(summary.offshore_will), 'Offshore will'));
    row.appendChild(
      comp.displayText('clientImportedWill', text(summary.importwillnumber), 'Imported will number')
    );
  },
  partyId(summary, index) {
    return summary[`party${index}_id_nr`] || summary[`party${index}_passport_nr`] || '';
  },
  renderParties(summary) {
    const row = U.id('clientOverviewParties');
    if (!row) return;
    row.innerHTML = '';

    const parties = [1, 2, 3, 4, 5]
      .map((index) => ({
        name: summary[`party${index}_full_name`],
        id: this.partyId(summary, index),
      }))
      .filter((party) => party.name);

    if (!parties.length) {
      const empty = document.createElement('p');
      empty.className = 'text-sm text-gray-500 mb-0';
      empty.textContent = 'No parties recorded.';
      row.appendChild(empty);
      return;
    }

    parties.forEach((party) => {
      const line = document.createElement('p');
      line.className = 'text-sm text-gray-800 mb-1';
      line.textContent = party.id ? `${party.name} — ${party.id}` : party.name;
      row.appendChild(line);
    });
  },
  renderFlag(container) {
    if (!container) return;
    const existing = container.querySelector('[data-client-overview-flag]');
    if (existing) existing.remove();

    const isFlagged = this.flaggedYn;
    const wrap = document.createElement('div');
    wrap.setAttribute('data-client-overview-flag', '1');
    wrap.className = 'inline-flex items-center gap-2';

    const flagIcon = svg.flag(40, { outline: !isFlagged });
    flagIcon.style.cursor = 'pointer';
    flagIcon.style.color = isFlagged ? '#3B71CA' : '#717171';
    flagIcon.title = isFlagged ? 'Remove flag' : 'Add flag';
    flagIcon.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (isFlagged) {
        this.promptRemoveFlag();
      } else {
        this.addFlag();
      }
    });
    wrap.appendChild(flagIcon);

    const label = document.createElement('span');
    label.className = 'text-sm whitespace-nowrap';
    label.style.color = isFlagged ? '#3B71CA' : '#717171';
    label.textContent = isFlagged ? 'Flagged' : 'Not flagged';
    wrap.appendChild(label);
    container.appendChild(wrap);
  },
  async promptRemoveFlag() {
    if (!this.flaggedYn) return;
    await comp.modal(
      'Remove flag',
      'Are you sure you want to remove this flag?',
      'thsTab.removeFlag()',
      ''
    );
  },
  async refreshFlagState() {
    const vars = { application_uuid: this.application_uuid };
    const res = await O.PREP([await O.mPOST('application/get-app-summary', vars)]);
    this.applyFlagState(res['application/get-app-summary']?.data || {});
  },
  async addFlag() {
    const vars = {
      log_application_view_uuid: this.logApplicationViewUuid,
      true_false: true,
    };
    try {
      const res = await O.PREP([await O.mPOST('application/upd-application-view-flag', vars)]);
      const payload = res['application/upd-application-view-flag'];
      const newUuid = payload?.data?.log_application_view_uuid ?? payload?.log_application_view_uuid;
      if (newUuid != null && String(newUuid).trim() !== '') {
        this.logApplicationViewUuid = String(newUuid).trim();
      } else {
        await this.refreshFlagState();
      }
      this.flaggedYn = true;
      this.renderFlag(U.id('clientOverviewStatus'));
    } catch (error) {
      comp.errorBox('Error', 'Failed to add flag. Please try again.');
    }
  },
  async removeFlag() {
    if (!this.flaggedYn) return;
    const vars = {
      log_application_view_uuid: this.logApplicationViewUuid,
      true_false: false,
    };
    try {
      await O.PREP([await O.mPOST('application/upd-application-view-flag', vars)]);
      this.flaggedYn = false;
      this.renderFlag(U.id('clientOverviewStatus'));
    } catch (error) {
      comp.errorBox('Error', 'Failed to remove flag. Please try again.');
    }
  },
};
